import { useNotifications } from '@/composables/useNotifications'
import { t } from '@/i18n'
import { router } from '@/router'
import type { Device } from '@/types/device'

import { isSemverLower } from './semver'

const MIN_ANDROID_VERSION = '2.4.4'
const DEPRECATED_ANDROID_VERSION = '2.3.3'
const DEPRECATED_IOS_VERSION = '2.4.2'
const WEBVIEW_VERSION = 111
const WINDOWS_VERSION = 'Windows NT 6'

export function isDeprecatedVersion(deviceInfo: Device, isDataphone = false) {
  if (
    (deviceInfo.platform === 'android' &&
      deviceInfo.nativeVersion &&
      isSemverLower(deviceInfo.nativeVersion, DEPRECATED_ANDROID_VERSION) &&
      !isDataphone) ||
    (deviceInfo.platform === 'ios' &&
      deviceInfo.nativeVersion &&
      isSemverLower(deviceInfo.nativeVersion, DEPRECATED_IOS_VERSION))
  ) {
    return true
  }
  return false
}

function notifyOldAndroidVersion(deviceInfo: Device, isDataphone = false) {
  if (
    deviceInfo.platform === 'android' &&
    deviceInfo.nativeVersion &&
    isSemverLower(deviceInfo.nativeVersion, MIN_ANDROID_VERSION) &&
    !isDataphone
  ) {
    const notification = useNotifications()
    notification.notifyError({
      id: 'update-app',
      title: t('notifications.update-apk.title'),
      description: t('notifications.update-apk.description'),
      important: true,
      onAction: () => {
        window.open('https://play.google.com/store/apps/details?id=app.last.pos', '_blank')
      }
    })
  }
}

function notifyDeprecatedAndroidVersion(deviceInfo: Device, isDataphone = false) {
  if (
    deviceInfo.platform === 'android' &&
    deviceInfo.nativeVersion &&
    isSemverLower(deviceInfo.nativeVersion, DEPRECATED_ANDROID_VERSION) &&
    !isDataphone
  ) {
    router.push({ name: 'updateDevice' })
  }
}

function notifyOldIOSVersion(deviceInfo: Device) {
  if (
    deviceInfo.platform === 'ios' &&
    deviceInfo.nativeVersion &&
    isSemverLower(deviceInfo.nativeVersion, DEPRECATED_IOS_VERSION)
  ) {
    router.push({ name: 'updateDevice' })
  }
}

function notifyOldVersionWebView(deviceInfo: Device) {
  if (
    deviceInfo.platform === 'android' &&
    parseFloat(deviceInfo.webviewVersion) < WEBVIEW_VERSION
  ) {
    const notification = useNotifications()
    notification.notifyError({
      id: 'update-webview',
      title: t('notifications.update-webview.title'),
      description: t('notifications.update-webview.description'),
      important: true,
      onAction: () => {
        window.open(
          'https://play.google.com/store/apps/details?id=com.google.android.webview',
          '_blank'
        )
      }
    })
  }
}

function notifyOldWindows(deviceInfo: Device) {
  if (deviceInfo.platform === 'electron' && deviceInfo.osVersion.includes(WINDOWS_VERSION)) {
    const notification = useNotifications()
    notification.notifyError({
      id: 'update-windows',
      title: t('notifications.update-windows.title'),
      description: t('notifications.update-windows.description'),
      important: true,
      onAction: () => {
        window.open(
          'https://help.last.app/portal/es/kb/articles/last-app-dejar%C3%A1-de-dar-soporte-a-windows-7-te-explicamos-por-qu%C3%A9#Por_qu_tomamos_esta_decisin',
          '_blank'
        )
      }
    })
  }
}

export function notifyDeprecatedVersions(device: Device, isDataphone = false) {
  notifyOldAndroidVersion(device, isDataphone)
  notifyOldVersionWebView(device)
  notifyOldWindows(device)
  notifyOldIOSVersion(device)
  notifyDeprecatedAndroidVersion(device, isDataphone)
}
